import { render, staticRenderFns } from "./BlockedItemVariationsList.vue?vue&type=template&id=3d37b99e&scoped=true"
import script from "./BlockedItemVariationsList.vue?vue&type=script&lang=js"
export * from "./BlockedItemVariationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37b99e",
  null
  
)

export default component.exports